/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import { theme, vars } from "app/client/ui2018/cssVars";

import { styled } from "grainjs";

export const cssInput = styled("input", `
  color: ${theme.inputFg};
  background-color: ${theme.inputBg};
  height: 30px;
  width: 100%;
  font-size: ${vars.mediumFontSize};
  border-radius: 3px;
  padding: 5px;
  border: 1px solid ${theme.inputBorder};
  outline: none;

  &::placeholder {
    color: ${theme.inputPlaceholderFg};
  }
`);
